import React, { FunctionComponent } from 'react'
import { DateTime } from 'luxon'

import BannerReferralsTable from './BannerReferralsTable'

import { BannerReferralsFilters } from '../../../typings/bannerReferrals'

import TableContext, {
  createTableContext,
} from '../../../contexts/TableContext'

type BannerReferralSorts =
  | 'referralDate'
  | 'referralProductName'
  | 'referralSubtracking'
  | 'clickDate'
  | 'clickProduct'
  | 'saleDate'
  | 'saleCommission'

export const BannerReferralsTableContext = createTableContext<
  BannerReferralsFilters,
  BannerReferralSorts
>()
const today = DateTime.local().toISODate()

const BannerReferralsContainer: FunctionComponent = () => {
  return (
    <TableContext<BannerReferralsFilters, BannerReferralSorts>
      Context={BannerReferralsTableContext}
      defaultFilters={{
        startDate: today,
        endDate: today,
        dateType: 'referralDate',
      }}
      queryParams={[
        'subtracking',
        'product',
        'endDate',
        'startDate',
        'dateRange',
        'dateType',
      ]}
    >
      <BannerReferralsTable />
    </TableContext>
  )
}

export default BannerReferralsContainer
